import React from "react";
import ListToolbarView, { ListToolbarViewProps, WithId } from "./ListToolbarView";

export type ProjectPanelListToolbarViewProps<T extends WithId> = Omit<ListToolbarViewProps<T>, "isInProjectlist">;

function ProjectPanelListToolbarView<T extends WithId>(props: ProjectPanelListToolbarViewProps<T>) {
  const className = ["project-panel-list-toolbar", props.className].filter(Boolean).join(" ");

  return <ListToolbarView {...props} className={className} isInProjectlist={true} />;
}

export default ProjectPanelListToolbarView;
